import { Order } from "src/app/core/models/order";

export class OutgoinCall {
    type!: CallType;
    caller!: Caller;
    callee!: Callee;
    order?: Order;
}

export class Callee {
    number!: string;
    name!: string;
}

export class Caller {
    name!: string;
}

export enum CallType {
    WithCustomer,
    WithBranche,
}